import { PRACTICES } from "@/data/practices";

export const toBoroughSlug = (borough: string): string =>
  borough.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

export const getUniqueBoroughs = (): string[] => {
  const boroughs = new Set(PRACTICES.map((p) => p.borough));
  return [...boroughs].sort();
};

export const getBoroughFromSlug = (slug: string): string | undefined => {
  const boroughs = getUniqueBoroughs();
  return boroughs.find((b) => toBoroughSlug(b) === slug);
};

export const getPracticesByBorough = (borough: string) =>
  PRACTICES.filter((p) => p.borough === borough);
